import(/* webpackMode: "eager" */ "/codebuild/output/src3644705884/src/apps/webapp/src/app/global-error.tsx");
